import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "projectStaff__content" }
const _hoisted_2 = { class: "fl-left" }
const _hoisted_3 = { class: "fl-right" }
const _hoisted_4 = { class: "break-word" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createTextVNode("确定要 "),
  /*#__PURE__*/_createElementVNode("b", null, "移除"),
  /*#__PURE__*/_createTextVNode(" 该成员?")
], -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("a", {
  href: "#",
  class: "text-error"
}, "移除", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_icon = _resolveComponent("app-icon")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_popconfirm = _resolveComponent("a-popconfirm")!
  const _component_app_table = _resolveComponent("app-table")!
  const _component_add_staff_modal = _resolveComponent("add-staff-modal")!
  const _component_a_card = _resolveComponent("a-card")!

  return (_openBlock(), _createBlock(_component_a_card, { class: "utils__pageContainer projectStaff" }, {
    title: _withCtx(() => [
      _createVNode(_component_router_link, {
        class: "link-goback",
        to: { name: 'role.list' }
      }, {
        default: _withCtx(() => [
          _createVNode(_component_app_icon, { type: "arrow-left" })
        ]),
        _: 1
      }, 8, ["to"]),
      _createTextVNode(" " + _toDisplayString(_ctx.title), 1)
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_a_form, {
          class: "fl-clean projectStaff__filterForm",
          form: _ctx.filterParam,
          layout: 'inline'
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              (!_ctx.isShow)
                ? (_openBlock(), _createBlock(_component_a_form_item, { key: 0 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_button, {
                        type: "primary",
                        onClick: _ctx.onAddStaff
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("添加人员")
                        ]),
                        _: 1
                      }, 8, ["onClick"]),
                      _createVNode(_component_a_button, {
                        type: "primary",
                        onClick: _ctx.onRemoveMuti
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("批量删除")
                        ]),
                        _: 1
                      }, 8, ["onClick"])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_a_form_item, { label: "员工" }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_input, {
                    value: _ctx.filterParam.nameOrPhone,
                    "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.filterParam.nameOrPhone) = $event)),
                    placeholder: "员工姓名 / 手机号码",
                    "allow-clear": ""
                  }, null, 8, ["value"])
                ]),
                _: 1
              }),
              _createVNode(_component_a_form_item, null, {
                default: _withCtx(() => [
                  _createVNode(_component_a_button, {
                    type: "primary",
                    ghost: "",
                    onClick: _ctx.onRefreshTable
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("查询")
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        }, 8, ["form"]),
        _createVNode(_component_app_table, {
          ref: "tableRef",
          size: "default",
          "row-key": "roleRelId",
          columns: _ctx.tableColumns,
          data: _ctx.loadTableData,
          alert: _ctx.isShow ? null : _ctx.tableOptions.alert,
          "row-selection": _ctx.isShow ? null : _ctx.tableOptions.rowSelection,
          "show-pagination": true
        }, {
          allDepartmentName: _withCtx(({ record }) => [
            _createElementVNode("span", _hoisted_4, _toDisplayString(record.allDepartmentName), 1)
          ]),
          action: _withCtx(({ record }) => [
            _createElementVNode("p", null, [
              _createVNode(_component_a_popconfirm, {
                placement: "top",
                onConfirm: ($event: any) => (_ctx.onRemove([record.roleRelId]))
              }, {
                title: _withCtx(() => [
                  _hoisted_5
                ]),
                default: _withCtx(() => [
                  _hoisted_6
                ]),
                _: 2
              }, 1032, ["onConfirm"])
            ])
          ]),
          _: 1
        }, 8, ["columns", "data", "alert", "row-selection"])
      ]),
      _createVNode(_component_add_staff_modal, {
        ref: "addItemRef",
        "load-staff-list": _ctx.onLoadStaffList,
        "submit-user-list": _ctx.onSubmitStaffList,
        title: "",
        onComplete: _ctx.onRefreshTable
      }, null, 8, ["load-staff-list", "submit-user-list", "onComplete"])
    ]),
    _: 1
  }))
}